import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const parchment: ThemeDefinition = {
  label: "Parchment",
  className: "theme-parchment",
  bg: "#f0e6d0",
  text: "#5c4428",
  textMuted: `color-mix(in srgb, #5c4428 60%, transparent)`,
  accent: "#b88030",
  glassRgb: "240,230,208",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, #5c4428 30%, transparent)`,
  selection: "#5c4428",
  selectionText: "#ffffff",
  gridColor: "#dcd0b8",
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(40,30,15,0.18)",
  gpuClear: hexToSrgb("#f0e6d0"),
  gpuGridLine: hexToLinear("#dcd0b8"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#b88030"),
  gpuAxisZ: hexToLinear("#5c4428"),
  axisXColor: "#b88030",
  axisZColor: "#5c4428",
  font: '"Libre Baskerville", serif',
  fontImport: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap',
};
